export const changePasswordInitialValues = {
  oldPassword: "",
  newPassword: "",
  confirmPassword: "",
};
